import { init } from "../init";
import { JiraProductDiscoveryPage } from "../pages/software/jira/product-discovery/jira-product-discovery-page";

init(JiraProductDiscoveryPage);
